import { FC } from 'react';
import { ProgressIndicator } from '~/components';
import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import {
  AlertMessages,
  StepsCompanyRegister,
  showAlert,
  useStores,
} from '~/utils';
import Address from './Address';
import CompanyRegister from './CompanyRegister';
import Contact from './Contact';
import DataCompany from './DataCompany';
import { initialValues, validationSchema } from './schema';

export type Props = {
  onNavigateId(id: number): void;
};

export const CompanyRegisterContainer: FC = () => {
  const navigate = useNavigate();
  const {
    clients: { companyRegister },
    utils: { setProgressId },
  } = useStores();

  const handleFormSubmit = async (values: CompanyRegister) => {
    await companyRegister(values);
    showAlert({
      message: AlertMessages.SUCCESS_COMPANY_REGISTER,
      type: 'success',
    });
    navigate(Routes.CLIENT_ACCOUNTS);
  };

  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={handleFormSubmit}
    >
      <CompanyRegister>
        <ProgressIndicator
          steps={[
            {
              id: StepsCompanyRegister.DATA,
              label: 'Dados da empresa',
              content: <DataCompany onNavigateId={(id) => setProgressId(id)} />,
            },
            {
              id: StepsCompanyRegister.CONTACT,
              label: 'Contatos',
              content: <Contact onNavigateId={(id) => setProgressId(id)} />,
            },
            {
              id: StepsCompanyRegister.ADDRESS,
              label: 'Endereço',
              content: <Address onNavigateId={(id) => setProgressId(id)} />,
            },
          ]}
        />
      </CompanyRegister>
    </FormBehavior>
  );
};

export default observer(CompanyRegisterContainer);
